// extracted by mini-css-extract-plugin
export default {"group":"formInput_group__ABBCu","formInput":"formInput_formInput__QY7CK","formInputLabel":"formInput_formInputLabel__XAyMM","shrink":"formInput_shrink__Gjjzy"};